import React from 'react';
import Highcharts from 'highcharts';
import { options } from './options';
import { sentimentByRating } from './templates/sentimentByRating';

export class SentimentByRatingChart extends React.Component {

  generateChart = (isFirstRender) => {
    const { chartId, data, xAxisTitle, tooltipFormatter, maxValue, colors, disableAnimation } = this.props;
    const copyChartOptions = Object.assign({}, options);
    if (colors) {
      copyChartOptions.colors = colors;
    }
    Highcharts.setOptions(copyChartOptions);
    const copyChartType = Object.assign({}, sentimentByRating);
    copyChartType.series = data;
    if (!copyChartType.chart) {
      copyChartType.chart = {};
    }
    copyChartType.chart.animation = !disableAnimation;

    // No data labels
    copyChartType.plotOptions.bar.dataLabels.enabled = false;

    if (xAxisTitle) {
      copyChartType.xAxis.title = {
        text: xAxisTitle
      };
    } else {
      copyChartType.xAxis.title = null;
    }

    // Format x axis labels to go from 1 to max
    const categories = [];
    for (let i = 0; i <= maxValue; ++i) {
      categories.push(i + '');
    }
    copyChartType.xAxis.categories = categories;
    copyChartType.xAxis.minPadding = 0;

    // Reverse the xAxis
    copyChartType.xAxis.reversed = true;

    // Format y axis labels to go from 0 to anything
    copyChartType.yAxis.min = 0;
    copyChartType.yAxis.max = 100;
    copyChartType.yAxis.minPadding = 0;
    copyChartType.yAxis.softMin = 0;
    copyChartType.yAxis.softMax = 100;
    copyChartType.yAxis.tickInterval = 25;

    // Labels with percent
    if (!copyChartType.yAxis.labels) {
      copyChartType.yAxis.labels = {};
    }
    copyChartType.yAxis.labels.format = '{value}%';

    copyChartType.tooltip = {
      enabled: false,
      shared: true,
      useHTML: true
    };

    // Hide any labels on Zero data.
    copyChartType.plotOptions.bar.dataLabels.formatter = function () {
      if (this.y === 0) {
        return null;
      } else {
        return this.y;
      }
    };

    if (tooltipFormatter) {
      copyChartType.tooltip.formatter = function () {
        return tooltipFormatter(this);
      };
    }
    copyChartType.plotOptions.series.animation = !disableAnimation;

    const chart = Highcharts.chart(chartId, copyChartType);
    if (isFirstRender) {
      chart.reflow();
    }
  };

  componentDidUpdate () {
    const { forceReflowBecauseOfBug } = this.props;
    this.generateChart(forceReflowBecauseOfBug);
  }

  componentDidMount () {
    this.generateChart(true);
  }

  render () {
    const { chartId, data, customChartContainerClass, customChartClass } = this.props;
    return (
      <div className={ `${!!customChartContainerClass && customChartContainerClass}` }>
        <div id={ chartId } className={ `${!!customChartClass && customChartClass}` } />
        { /* We need to use data prop somewhere in render or React won't watch it for changes. */ }
        <div key={ data ? data.length : 0 } />
      </div>
    );
  }
}
